import React from 'react'

import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Span
} from 'components'
import { If, Then } from 'react-if'
import { IConsolidacaoTableEntity } from 'services/NGT/EffectiveConsolidation'
import { COLORS, FORMAT } from 'utils'

import { CollapsibleTable } from '../CollapsibleTable/CollapsibleTable'

interface IReportTable {
  tableData: IConsolidacaoTableEntity
  currentYear: number
  titleHeader: string
  isGeneratePDF: boolean
}

export const ReportTable: React.FC<IReportTable> = ({
  tableData,
  currentYear,
  titleHeader,
  isGeneratePDF
}) => {
  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled backgroundColor={COLORS.blueFonts}>
              <TableCellStyled
                align="center"
                textColor={COLORS.lightGray}
                colSpan={2}
              >
                {titleHeader}
              </TableCellStyled>
              <TableCellStyled
                align="center"
                textColor={COLORS.white}
                colSpan={2}
              >
                {currentYear - 1}
              </TableCellStyled>
              <TableCellStyled
                align="center"
                textColor={COLORS.lightGray}
                colSpan={24}
              >
                HNT X HE - {currentYear}
              </TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled colSpan={2} />
              <TableCellStyled colSpan={2} align="center">
                Dez
              </TableCellStyled>
              <TableCellStyled colSpan={2} align="center">
                Jan
              </TableCellStyled>
              <TableCellStyled colSpan={2} align="center">
                Fev
              </TableCellStyled>
              <TableCellStyled colSpan={2} align="center">
                Mar
              </TableCellStyled>
              <TableCellStyled colSpan={2} align="center">
                Abr
              </TableCellStyled>
              <TableCellStyled colSpan={2} align="center">
                Mai
              </TableCellStyled>
              <TableCellStyled colSpan={2} align="center">
                Jun
              </TableCellStyled>
              <TableCellStyled colSpan={2} align="center">
                Jul
              </TableCellStyled>
              <TableCellStyled colSpan={2} align="center">
                Ago
              </TableCellStyled>
              <TableCellStyled colSpan={2} align="center">
                Set
              </TableCellStyled>
              <TableCellStyled colSpan={2} align="center">
                Out
              </TableCellStyled>
              <TableCellStyled colSpan={2} align="center">
                Nov
              </TableCellStyled>
              <TableCellStyled colSpan={2} align="center">
                Dez
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled colSpan={2} />
              <TableCellStyled align="center">HNT</TableCellStyled>
              <TableCellStyled align="center">HE</TableCellStyled>
              <TableCellStyled align="center">HNT</TableCellStyled>
              <TableCellStyled align="center">HE</TableCellStyled>
              <TableCellStyled align="center">HNT</TableCellStyled>
              <TableCellStyled align="center">HE</TableCellStyled>
              <TableCellStyled align="center">HNT</TableCellStyled>
              <TableCellStyled align="center">HE</TableCellStyled>
              <TableCellStyled align="center">HNT</TableCellStyled>
              <TableCellStyled align="center">HE</TableCellStyled>
              <TableCellStyled align="center">HNT</TableCellStyled>
              <TableCellStyled align="center">HE</TableCellStyled>
              <TableCellStyled align="center">HNT</TableCellStyled>
              <TableCellStyled align="center">HE</TableCellStyled>
              <TableCellStyled align="center">HNT</TableCellStyled>
              <TableCellStyled align="center">HE</TableCellStyled>
              <TableCellStyled align="center">HNT</TableCellStyled>
              <TableCellStyled align="center">HE</TableCellStyled>
              <TableCellStyled align="center">HNT</TableCellStyled>
              <TableCellStyled align="center">HE</TableCellStyled>
              <TableCellStyled align="center">HNT</TableCellStyled>
              <TableCellStyled align="center">HE</TableCellStyled>
              <TableCellStyled align="center">HNT</TableCellStyled>
              <TableCellStyled align="center">HE</TableCellStyled>
              <TableCellStyled align="center">HNT</TableCellStyled>
              <TableCellStyled align="center">HE</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.items.length > 0 &&
              tableData?.items.map((row, index) => (
                <CollapsibleTable
                  key={index}
                  row={row}
                  isGeneratePDF={isGeneratePDF}
                />
              ))}

            <TableRowStyled backgroundColor={COLORS.tableColor}>
              <TableCellStyled colSpan={2}>
                <Span text="TOTAL:" fontWeight="bold" />
              </TableCellStyled>

              <React.Fragment key={12}>
                <TableCellStyled align="center">
                  {tableData?.total?.length >= 12
                    ? tableData?.total[12].info?.horaNormal?.toLocaleString(
                      'pt-br'
                    )
                    : 0}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {tableData?.total?.length >= 12
                    ? tableData?.total[12].info?.horaExtra?.toLocaleString(
                      'pt-br'
                    )
                    : 0}
                </TableCellStyled>
              </React.Fragment>

              {tableData?.total?.map(({ info }, index) => (
                <If condition={index !== 12}>
                  <Then>
                    <React.Fragment key={index}>
                      <TableCellStyled align="center">
                        {info?.horaNormal?.toLocaleString(
                          'pt-br'
                        )}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {info?.horaExtra?.toLocaleString(
                          'pt-br'
                        )}
                      </TableCellStyled>
                    </React.Fragment>
                  </Then>
                </If>
              ))}
            </TableRowStyled>
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
    </>
  )
}
